import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	aguardando: false,
	filtro: {
		data_inicial: `${new Date().getFullYear()}/01/01`,
		data_final: `${new Date().getFullYear()}/12/31`
	},
	listaAnaliticaReceita: [],
	listaAnaliticaDespesa: [],
	listaCompetencia: [],
	listaGrupo: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DRE_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DRE_SET_FILTRO':
			return {
				...state,
				filtro: action.payload
			};

		case 'DRE_LISTADO':
            return {
                ...state, 
                listaDRE: action.payload.data
            };

		case 'DRE_RECEITA_LISTADO':
            return {
                ...state, 
                listaAnaliticaReceita: action.payload.data
            };

		case 'DRE_DESPESA_LISTADO':
            return {
                ...state, 
                listaAnaliticaDespesa: action.payload.data
            };

		case 'DRE_COMPETENCIA_LISTADO':
            return {
                ...state, 
                listaCompetencia: action.payload.data
            };

		case 'DRE_GRUPO_LISTADO':
            return {
                ...state, 
                listaGrupo: action.payload.data
            };
			
        default:
            return state;
    }
}
